import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18 18L9.5 12L18 6V18ZM8 18H6V6H8V18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SkipPrevious"
);
